<template>
  <VanDialog :show="show" @update:show="emit('update:show')" teleport="body">
    <template #title>
      <div class="text-center text-base font-bold">{{ title }}</div>
      <p
        v-if="description"
        class="text-center text-base-content/50 text-xs px-6 pt-2"
      >
        {{ description }}
      </p>
    </template>
    <div class="flex flex-col gap-4 px-6">
      <VanField
        v-model="text"
        class="mt-2.5"
        :type="type"
        :name="title"
        :autosize="{ minHeight: 24, maxHeight: 300 }"
        :maxlength="maxLength"
        :show-word-limit="!!maxLength"
      />
    </div>

    <template #footer>
      <div class="flex justify-center py-4">
        <button class="btn btn-primary btn-sm mr-2" @click="clickConfirm">
          {{ t("Buttons.confirm") }}
        </button>

        <button
          class="btn btn-sm btn-outline"
          @click="emit('update:show', false)"
        >
          {{ t(`story.g.cancel`) }}
        </button>
      </div>
    </template>
  </VanDialog>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { PropType, watch } from "vue";
import { ref } from "vue";
import i18n from "@/locales";
import { FieldType } from "vant";
const { t } = useI18n();
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    default: i18n.global.t("ConfirmModal.enterContent"),
  },
  text: {
    type: String,
    default: "",
  },
  type: {
    type: String as PropType<FieldType>,
    default: "text",
  },
  description: {
    type: String,
    default: "",
  },
  maxLength: {
    type: Number,
  },
});

const emit = defineEmits(["update:show", "confirm"]);
const text = ref("");

watch(
  () => props.show,
  (val) => {
    if (val) text.value = props.text;
  }
);

const clickConfirm = async () => {
  emit("confirm", text.value);
};
</script>
